import React from "react";
import { Spin } from "antd";

const Loader = (props) => {
  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        position: "fixed",
        top: "0",
        left: "0",
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        zIndex: "9",
      }}
    >
      <Spin {...props} />
    </div>
  );
};

export default Loader;
